import React from "react";
import { useTypewriter } from "react-simple-typewriter";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const TypewriterMarkdown = ({ text, onDone }) => {
  const [typewriterText] = useTypewriter({
    words: [text],
    loop: 1,
    typeSpeed: 10,
    deleteSpeed: 0,
    delaySpeed: 300,
    onLoopDone: onDone,
  });

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        a: ({ href, children }) => (
          <a
            href={href}
            target="_self"
            rel="noopener noreferrer"
            style={{
              color: "#fa9a25",
              textDecoration: "underline",
            }}
          >
            {children}
          </a>
        ),
      }}
      classname=""
    >
      {typewriterText}
    </ReactMarkdown>
  );
};

export default TypewriterMarkdown;
